import { render, staticRenderFns } from "./orderdetail.vue?vue&type=template&id=9da83554&"
import script from "./orderdetail.vue?vue&type=script&lang=js&"
export * from "./orderdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports